import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '$store/constants/reducerPaths';
import { baseQuery } from '$store/utils/baseQuery';
import { getAllCurrencies } from './queries/get-all-currencies';

export const currenciesApi = createApi({
  reducerPath: ReducerPaths.CURRENCIES,
  baseQuery,
  tagTypes: ['Currencies'],
  endpoints: (builder) => ({
    getAllCurrencies: getAllCurrencies(builder),
  }),
});

export const { useGetAllCurrenciesQuery } = currenciesApi;
